import React from "react";

import { useTranslation } from "react-i18next";

import {
  Column,
  Flex,
  Wrapper,
  Title,
  Description,
  Container,
  MacroTitle,
  Link,
} from "./styles";
import { useOpticsStore } from "../../../../stores/use-optics-store";
import { OVERVIEW_TEMPLATES } from "./defaults";

function Overview() {
  const { t } = useTranslation();
  const setMacro = useOpticsStore((state) => state.setMacro);

  const prefix = "overview.";
  const templatesPrefix = "overview.macros.";

  return (
    <Wrapper>
      <Flex style={{ marginBottom: "40px" }}>
        <Column>
          <Title>{t(prefix + "title")}</Title>
          <Description>{t(prefix + "description")}</Description>
        </Column>
      </Flex>

      <Container>
        {OVERVIEW_TEMPLATES.map(({ macro, title, link, Component }) => (
          <Column key={macro} style={{ rowGap: "16px", flex: 1 }}>
            <Flex>
              <MacroTitle>{t(templatesPrefix + title)}</MacroTitle>
              <Link onClick={() => setMacro({ key: macro })}>
                {t(templatesPrefix + link)}
              </Link>
            </Flex>
            <Component />
          </Column>
        ))}
      </Container>
    </Wrapper>
  );
}

export default Overview;
